import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_BALANCE,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FILL_IN_RECEIVER_DETAILS_CORRECTLY,
	STR_HOTEL,
	STR_HOTEL_MENU,
	STR_LOGOUT,
	STR_MIN_50000,
	STR_MY_COACH,
	STR_MY_HOTELS,
	STR_MY_STUDENTS,
	STR_NO_PERMISSION,
	STR_NO_RECORD,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECEIVER_METHOD,
	STR_RECEIVER_NAME,
	STR_RECEIVER_NUMBER,
	STR_REVENUE,
	STR_REVENUE_AND_WITHDRAWALS,
	STR_ROOM_BOOKINGS,
	STR_ROOMS,
	STR_SEND_WITHDRAW_REQUEST,
	STR_SET_CURRENCY,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TAB_REVENUES,
	STR_TAB_WITHDRAWALS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_WITHDRAWAL_HISTORY
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdCheckCircle, MdContactPage, MdDashboard, MdInfoOutline, MdList, MdLogout, MdManageAccounts, MdMoney, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWarning, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import WelcomeSlider from "../ones/WelcomeSlider";
import { RiHotelLine } from "react-icons/ri";
import TabbedView from "../components/TabbedView";
import OneRevenue from "../ones/OneRevenue";
import OneWithdrawal from "../ones/OneWithdrawal";

export default function View({ hotelId }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [hotelData,  setHotelData] = useState(null);
	const [hotelBalance,  setHotelBalance] = useState(null);
	const [hotelRevenues,  setHotelRevenues] = useState(null);
	const [hotelWithdrawals,  setHotelWithdrawals] = useState(null);

	const [receiverMethod, setReceiverMethod] = useState('mpesa');
	const [receiverNumber, setReceiverNumber] = useState('');
	const [receiverName, setReceiverName] = useState('');
	const [amount, setAmount] = useState(0);

	const [isWithdrawalOpSuccessful, setIsWithdrawalOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			getHotelData(),
			getHotelBalance(),
			getHotelWithdrawals(),
			getHotelRevenues(),
		])
		setReady(true);
	}

	function resetWithdrawalFields() {
		setAmount(0);
		setReceiverMethod('mpesa');
		setReceiverName('');
		setReceiverNumber('');
	}

	async function getHotelData() {
		await callApi('get-current-hotel-data', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function getHotelBalance() {
		await callApi('get-hotel-balance', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelBalance(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function getHotelWithdrawals() {
		await callApi('get-hotel-withdrawals', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelWithdrawals(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}
	
	async function getHotelRevenues() {
		await callApi('get-hotel-revenues', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelRevenues(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function sendWithdrawalRequest() {
		if(Number(amount) >= 50000) {
			if(receiverMethod && receiverMethod.trim().length > 0) {
				if(receiverNumber && receiverNumber.trim().length > 0) {
					if(receiverName && receiverName.trim().length > 0) {
						setLoading(true);
						await callApi(
							'send-withdrawal-request',
							{
								hotelId,
								amount,
								receiverNumber,
								receiverName,
								receiverMethod,
							}
						).then((response) => {
							if(response.status === 1) {
								resetWithdrawalFields();
								getHotelWithdrawals();
								setIsWithdrawalOpSuccessful(true);
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError(STR_FILL_IN_RECEIVER_DETAILS_CORRECTLY[appContext.language]);
					}
				} else {
					appContext.tellError(STR_FILL_IN_RECEIVER_DETAILS_CORRECTLY[appContext.language]);
				}
			} else {
				appContext.tellError(STR_FILL_IN_RECEIVER_DETAILS_CORRECTLY[appContext.language]);
			}
		} else {
			appContext.tellError(STR_MIN_50000[appContext.language]);
		}
	}

	const Revenues = (
		<div
			className=""
			style={{
				width: "100%"
			}}
		>
			{
				(hotelRevenues && hotelRevenues.length > 0) ?
				hotelRevenues.map((item, i) => {
					return (
						<OneRevenue 
							key={i}
							data={item}
						/>
					)
				})
				:
				<h6>{STR_NO_RECORD[appContext.language]}</h6>
			}
		</div>
	);

	const Withdrawals = (
		<div
			className=""
			style={{
				width: "100%"
			}}
		>
			<div className="card mNoShadow mt-2">
				<div className="card-body">
					<h6 className="card-title">
						{STR_SEND_WITHDRAW_REQUEST[appContext.language]}
					</h6>

					{
						(isWithdrawalOpSuccessful) ?
						<div
							className="text-center mt-4 mb-4"
						>
							<MdCheckCircle size={48} className="text-muted"/>
						</div>
						:
						<>
							<div className="mt-3 mb-3">
								<label className="form-label">{STR_RECEIVER_METHOD[appContext.language]}</label>
								<select
									className="form-control"
									value={receiverMethod}
									onChange={(e) => setReceiverMethod(e.target.value)}
								>
									<option value='mpesa'>Vodacom MPESA</option>
									<option value='airtel_money'>Airtel Money</option>
									<option value='mixx_by_yas'>Mixx by Yas</option>
									<option value='halopesa'>HaloPesa</option>
									<option value='tpesa'>T-PESA</option>
									<option value='crdb'>CRDB</option>
									<option value='nmb'>NMB</option>
									<option value='nbc'>NBC</option>
								</select>
							</div>

							<div className="mt-3 mb-3">
								<label className="form-label">{STR_RECEIVER_NUMBER[appContext.language]}</label>
								<input
									className="form-control"
									value={receiverNumber}
									onChange={(e) => setReceiverNumber(e.target.value)}
								/>
							</div>

							<div className="mt-3 mb-3">
								<label className="form-label">{STR_RECEIVER_NAME[appContext.language]}</label>
								<input
									className="form-control"
									value={receiverName}
									onChange={(e) => setReceiverName(e.target.value)}
								/>
							</div>

							<div className="mt-3 mb-3">
								<label className="form-label">{STR_AMOUNT_2[appContext.language]}</label>
								<input
									className="form-control"
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
								/>
								<div className="form-text">
									{STR_MIN_50000[appContext.language]}
								</div>
							</div>

							<div className="mt-3 mb-3">
								<button
									className="btn btn-primary btn-padded btn-rounded btn-block"
									onClick={sendWithdrawalRequest}
								>
									{STR_SUBMIT[appContext.language]}
								</button>
							</div>
						</>
					}

				</div>
			</div>


			<h6
				className="font-bold text-primary mt-5 mb-2"
				style={{
					fontSize: "18px"
				}}
			>
				{STR_WITHDRAWAL_HISTORY[appContext.language]}
			</h6>
			<hr/>

			{
				(hotelWithdrawals && hotelWithdrawals.length > 0) ?
				hotelWithdrawals.map((item, i) => {
					return (
						<OneWithdrawal
							key={i}
							data={item}
						/>
					)
				})
				:
				<h6>{STR_NO_RECORD[appContext.language]}</h6>
			}
		</div>
	);

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && hotelData) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						{
							(Number(appContext.currentUserData.id) === Number(hotelData.managerId)) ?
							<div className="col-md-12">
								<div className="card mb-5">
									<div className="card-body text-center">
										
										<h6
											className="text-primary font-light mt-3 mb-3"
											style={{
												fontSize: "28px"
											}}
										>
											{hotelData.name}
										</h6>

										<span className="badge bg-secondary">{STR_HOTEL[appContext.language]}</span>
									</div>
								</div>

								<h6 className="main-section-title">
									{STR_REVENUE_AND_WITHDRAWALS[appContext.language]}
								</h6>


								<div className="row">
									<div className="col-12">
										<div className="card bg-secondary">
											<div className="card-body">
												

												<h6
													className="font-light"
													style={{
														fontSize: "32px"
													}}
												>
													{formatMoney(hotelBalance)}
												</h6>

												<h6
													className="font-semi-bold text-end"
													style={{
														fontSize: "14px"
													}}
												>
													{STR_BALANCE[appContext.language]}
												</h6>

											</div>
										</div>
									</div>

									<div className="col-12">
										<TabbedView
											tabs={[
												{
													id: 'revenues',
													label: STR_TAB_REVENUES[appContext.language],
													content: Revenues
												},
												{
													id: 'withdrawals',
													label: STR_TAB_WITHDRAWALS[appContext.language],
													content: Withdrawals
												},
											]}
										/>
									</div>
								</div>

							</div>
							:
							<div className="col-md-12">
								<div className="card">
									<div className="card-body text-center">
										<MdWarning size={56} className="text-secondary"/>

										<h6
											style={{
												fontSize: "22px"
											}}
											className="font-semi-bold"
										>
											{STR_NO_PERMISSION[appContext.language]}
										</h6>
									</div>
								</div>
							</div>
						}
					 

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}